import { SvgProps } from "components/icons/types";

export const PieChart = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_6655_2311)">
      <path
        d="M9.66706 19.9752C7.24254 19.9752 4.91732 19.0121 3.20292 17.2977C1.48853 15.5833 0.525391 13.2581 0.525391 10.8336C0.525391 8.40904 1.48853 6.08382 3.20292 4.36943C4.91732 2.65503 7.24254 1.69189 9.66706 1.69189H10.5004L10.5112 2.52523L10.5004 10.0002H18.8087V10.8336C18.8061 13.2573 17.8421 15.5809 16.1283 17.2948C14.4144 19.0086 12.0908 19.9726 9.66706 19.9752V19.9752ZM8.84372 3.40439C7.44453 3.55959 6.1176 4.10675 5.01569 4.98289C3.91377 5.85902 3.08166 7.02852 2.61515 8.35675C2.14864 9.68498 2.06669 11.118 2.37873 12.4907C2.69077 13.8635 3.38412 15.1202 4.37897 16.1163C5.37381 17.1123 6.62971 17.8072 8.00209 18.1209C9.37446 18.4346 10.8075 18.3544 12.1363 17.8895C13.4651 17.4246 14.6356 16.5939 15.5131 15.493C16.3906 14.3922 16.9393 13.0659 17.0962 11.6669H8.83372L8.84372 3.40439Z"
        fill="currentColor"
      />
      <path
        d="M13.8488 1.90665C14.9935 2.20613 16.0379 2.80486 16.8747 3.64138C17.7115 4.4779 18.3106 5.52206 18.6105 6.66665H13.8488V1.90665ZM12.1821 0.0283203V8.33332H20.4888C20.4781 6.13372 19.5994 4.02729 18.0439 2.47207C16.4883 0.916859 14.3817 0.0386169 12.1821 0.0283203V0.0283203Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6655_2311">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
